import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { cn } from "@/utils/cn";
import {
  isWorkType,
  WORK_TYPES,
  type WorkType,
} from "./shift-code-add-dialog-utils";

export function WorkTypeField({
  value,
  disabled = false,
  onChange,
}: {
  readonly value: WorkType;
  readonly disabled?: boolean;
  readonly onChange: (value: WorkType) => void;
}) {
  return (
    <div>
      <span className="sr-only">타입</span>
      <ToggleGroup
        type="single"
        aria-label="타입"
        value={value}
        disabled={disabled}
        className="flex w-full justify-start gap-0 border-b border-[#E4E7EC] bg-white"
        onValueChange={(nextValue) => {
          if (isWorkType(nextValue)) onChange(nextValue);
        }}
      >
        {WORK_TYPES.map((item) => (
          <ToggleGroupItem
            key={item}
            value={item}
            className={cn(
              "h-12 min-w-24 rounded-none border-b-2 border-transparent px-4 text-sm font-semibold text-[#667085] hover:bg-[#F8FAFC] hover:text-[#0E59C6] data-[state=on]:border-[#0E59C6] data-[state=on]:bg-white data-[state=on]:text-[#0E59C6]",
              disabled && "cursor-not-allowed opacity-45"
            )}
          >
            {item}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
